export default __webpack_public_path__ + "static/media/light.48359573.svg";